import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import Cookies from 'js-cookie';

const ProtectedRoute = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const token = Cookies.get('accessToken');

  return token
    ? <Outlet />
    : <Navigate to="/" replace />;
};

export default ProtectedRoute;
